import clsx from "clsx";
import Portal from "../components/Portal";
import Divider from "./base/Divider";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";

export function IntegrationDialog({
    isOpen,
    title,
    content,
    height = 'auto',
    width,
    onCancel,
    fontSize,
    size = 'medium',
  }) {
    if (!isOpen) {
      return null;
    }
    function renderContent() {
      return typeof content === 'function' ? content() : content;
    }

    return (
        <Dialog
        open={isOpen}
        onClose={onCancel}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          },
        }}
      >
      <DialogTitle
          sx={{
            pb: 1,
            fontSize: "20px",
            fontWeight: 600,
            color: "#1a1a1a",
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ pt: 5 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 1 }}>
            {renderContent()}
          </Box>
        </DialogContent>
      </Dialog>
    )
  }